/**
 * How long a remembered file is trusted. An entry is only ever a head start on a fetch, so this is short:
 * long enough to cover stepping through a listing the caller is looking at, short enough that a file
 * deleted or banned since that listing stops being served from here. Nothing removes an entry when a later
 * listing omits it, so without this bound a stale record would outlive the tab. Five minutes.
 */
export const MEDIA_FILE_CACHE_TTL_MS = 300_000;
const entries = new Map();
/** Remembers files a surface already has. Later writes win, so a fetched file replaces a listed one. */
export function rememberMediaFiles(files) {
    const rememberedAt = Date.now();
    files.forEach((file) => entries.set(file.id, { file, rememberedAt }));
}
export function readRememberedMediaFile(id) {
    const entry = entries.get(id);
    if (entry === undefined) {
        return undefined;
    }
    if (Date.now() - entry.rememberedAt >= MEDIA_FILE_CACHE_TTL_MS) {
        // Drop it rather than keep answering with it: the caller fetches, and a fresh answer is remembered.
        entries.delete(id);
        return undefined;
    }
    return entry.file;
}
/** Only for tests: the cache otherwise lives as long as the tab, bounded by the freshness window above. */
export function forgetRememberedMediaFiles() {
    entries.clear();
}
